import AuthNoIndex from "@/components/AuthNoIndex";
import { Outlet } from "react-router";

export default function AuthLayout() {
    return (
        <>
            <AuthNoIndex />
            <Outlet />
        </>
    );
}
